import { Union, Record } from "./fable_modules/fable-library.4.5.0/Types.js";
import { DocumentContent, ScanResults_$reflection, ScanError_$reflection, ScanResult_$reflection, DocumentContent_$reflection } from "./Shared/Shared.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.4.5.0/Choice.js";
import { array_type, string_type, record_type, option_type, union_type } from "./fable_modules/fable-library.4.5.0/Reflection.js";
import { orElse, value as value_98, unwrap, map, defaultArg, some } from "./fable_modules/fable-library.4.5.0/Option.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library.4.5.0/MapUtil.js";
import { singleton as singleton_1, cons, ofArray, empty } from "./fable_modules/fable-library.4.5.0/List.js";
import { toString } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { stringHash, createObj, uncurry2 } from "./fable_modules/fable-library.4.5.0/Util.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useReact_useReducer_2B9E6EA0, useFeliz_React__React_useState_Static_1505 } from "./fable_modules/Feliz.2.7.0/React.fs.js";
import { toList, empty as empty_1, singleton, collect, delay, toArray } from "./fable_modules/fable-library.4.5.0/Seq.js";
import { rangeDouble } from "./fable_modules/fable-library.4.5.0/Range.js";
import { tryFind, map as map_1 } from "./fable_modules/fable-library.4.5.0/Array.js";
import { Interop_reactApi } from "./fable_modules/Feliz.2.7.0/Interop.fs.js";
import { RouterModule_router, RouterModule_urlSegments } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export class FileEntry extends Record {
    constructor(Document$, Scan) {
        super();
        this.Document = Document$;
        this.Scan = Scan;
    }
}

export function FileEntry_$reflection() {
    return record_type("Index.FileEntry", [], FileEntry, () => [["Document", DocumentContent_$reflection()], ["Scan", option_type(union_type("Microsoft.FSharp.Core.FSharpResult`2", [ScanResult_$reflection(), ScanError_$reflection()], FSharpResult$2, () => [[["ResultValue", ScanResult_$reflection()]], [["ErrorValue", ScanError_$reflection()]]]))]]);
}

export class Model extends Record {
    constructor(CurrentUrl, Input) {
        super();
        this.CurrentUrl = CurrentUrl;
        this.Input = Input;
    }
}

export function Model_$reflection() {
    return record_type("Index.Model", [], Model, () => [["CurrentUrl", array_type(string_type)], ["Input", string_type]]);
}

export class Msg extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["SetInput"];
    }
}

export function Msg_$reflection() {
    return union_type("Index.Msg", [], Msg, () => [[["Item", string_type]]]);
}

export function init() {
    return new Model([], "");
}

export function update(model, msg) {
    return new Model(model.CurrentUrl, msg.fields[0]);
}

export function uploadFiles(files, callback) {
    let properties_2;
    try {
        let pr_4;
        let pr_3;
        let pr_2;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(ScanResults_$reflection(), void 0, void 0);
        const data_1 = files;
        const caseStrategy_2 = void 0;
        const extra_2 = void 0;
        try {
            const properties_3 = Helper_withProperties(void 0, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(array_type(DocumentContent_$reflection()), caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch("/api/v1/documents/scan", properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(ScanResults_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_2 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_3 = (pr_2.then((res) => {
            if (res.tag === 1) {
                const err = res.fields[0];
                switch (err.tag) {
                    case 3: {
                        console.error(some("Network error"), err.fields[0].message);
                        break;
                    }
                    case 1: {
                        console.error(some("Decoding failed"), err.fields[0]);
                        break;
                    }
                    case 0: {
                        console.error(some("Preparing request failed"), err.fields[0].message);
                        break;
                    }
                    default: {
                        const pr_1 = err.fields[0].json();
                        pr_1.then((json) => {
                            console.error(some("Fetch failed"), json);
                        });
                    }
                }
            }
            else {
                callback(res.fields[0]);
            }
        }));
        pr_4 = (pr_3.then(void 0, ((ex) => {
            console.error(some("Error scanning documents"), ex.message);
        })));
        pr_4.then();
    }
    catch (e) {
        console.error(some("Error uploading files"), e.message);
    }
}

export function tryReadFile(file) {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
        reader.onload = ((ev) => {
            const content = reader.result;
            const byteArray = new Uint8Array(content);
            console.debug("Reader load event", ev);
            resolve(new DocumentContent(file.name, byteArray));
        });
        reader.onerror = ((ev_1) => {
            console.error(some("Could not read file"), ev_1);
            reject(new Error("Could not read file"));
        });
        reader.readAsArrayBuffer(file);
    });
}

export function FileDrop() {
    let elems_5, elems_4, elems_3, elems_7, elems_6;
    const patternInput = useFeliz_React__React_useState_Static_1505([]);
    const setFiles = patternInput[1];
    const xs_13 = [createElement("div", createObj(ofArray([["id", "drop-zone"], ["onDrop", (ev) => {
        console.debug("Dropped here:", ev);
        ev.preventDefault();
        const itemsOpt = ev.dataTransfer.items;
        let files_2;
        if (itemsOpt == null) {
            files_2 = [];
        }
        else {
            const items = value_98(itemsOpt);
            const files_1 = toArray(delay(() => collect((itemIdx) => {
                const item = items[itemIdx];
                if (item.kind === "file") {
                    return singleton(item.getAsFile());
                }
                else {
                    console.error(some("Upload is not a file!"), item.kind);
                    return empty_1();
                }
            }, rangeDouble(0, 1, items.length - 1))));
            setFiles(map_1((file_2) => {
                console.debug("File name hash", stringHash(file_2.name));
                return new FileEntry(new DocumentContent(file_2.name, new Uint8Array([])), void 0);
            }, files_1));
            console.debug("Set file names. Starting loading files");
            files_2 = map_1(tryReadFile, files_1);
        }
        console.info(some(`Uploading ${files_2.length} files for scanning`));
        const pr = Promise.all(files_2);
        pr.then((files_3) => {
            let entries;
            const entries_1 = map_1((file_4) => (new FileEntry(file_4, void 0)), files_3);
            setFiles(entries_1);
            uploadFiles(files_3, (entries = entries_1, (results) => {
                console.debug("Existing entries", entries);
                console.debug("Results", results);
                setFiles(map_1((file) => (new FileEntry(file.Document, orElse(map((ResultValue) => (new FSharpResult$2(0, [ResultValue])), tryFind((scan) => (scan.Filename === file.Document.Name), results.Results)), map((ErrorValue) => (new FSharpResult$2(1, [ErrorValue])), tryFind((error) => (error.FileName === file.Document.Name), results.Errors))))), entries));
            }));
        });
    }], ["onDragOver", (ev_1) => {
        ev_1.preventDefault();
        console.debug("Dragging over drop zone");
    }], (elems_5 = [createElement("p", {
        style: {
            flexGrow: 1,
            textAlign: "center",
        },
        children: "Drag a file to be scanned here.",
    }), createElement("div", createObj(singleton_1((elems_4 = [createElement("form", createObj(ofArray([["action", ""], ["method", ""], ["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "start",
        gap: 10 + "px",
        padding: 5 + "px",
    }], (elems_3 = [createElement("input", {
        type: "file",
        accept: ".doc, .docx, .pdf, image/png, image/jpeg",
    }), createElement("input", {
        type: "submit",
        value: "Upload",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))]))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])]))), createElement("div", createObj(ofArray([["style", {
        width: 100 + "%",
    }], (elems_7 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 10 + "px",
    }], (elems_6 = toList(delay(() => map_1((file_5) => {
        let elems_2, elems, elems_1;
        return createElement("div", createObj(ofArray([["style", {
            fontSize: 0.8 + "rem",
            padding: 5 + "px",
            border: ((((2 + "px") + " ") + "solid") + " ") + "gainsboro",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: 80 + "%",
            maxWidth: 1200 + "px",
        }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
            flexGrow: 1,
        }], (elems = [createElement("p", {
            style: {
                overflowX: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                maxWidth: 60 + "ch",
            },
            title: file_5.Document.Name,
            children: file_5.Document.Name,
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
            paddingLeft: 10 + "px",
            paddingRight: 10 + "px",
        }], (elems_1 = toList(delay(() => {
            if (file_5.Document.Content.length === 0) {
                return singleton(createElement("p", {
                    children: ["Loading file..."],
                }));
            }
            else if (file_5.Scan == null) {
                return singleton(createElement("p", {
                    children: ["Scanning file..."],
                }));
            }
            else {
                let color_1;
                const matchValue = file_5.Scan;
                let matchResult, scan_2;
                if (matchValue != null) {
                    const copyOfStruct = matchValue;
                    if (copyOfStruct.tag === 0) {
                        if (!copyOfStruct.fields[0].VirusFound) {
                            matchResult = 0;
                            scan_2 = copyOfStruct.fields[0];
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0: {
                        color_1 = "#65db65";
                        break;
                    }
                    default:
                        color_1 = "#ff0000ab";
                }
                const scan_3 = value_98(file_5.Scan);
                return singleton(createElement("div", {
                    style: {
                        padding: 3 + "px",
                        backgroundColor: color_1,
                    },
                    children: (scan_3.tag === 1) ? scan_3.fields[0].Message : (scan_3.fields[0].VirusFound ? "Virus!" : "OK"),
                }));
            }
        })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])));
    }, patternInput[0]))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])])))];
    return react.createElement(react.Fragment, {}, ...xs_13);
}

export function view(model, dispatch) {
    let children, elems_1, elems, elems_3, elems_2;
    const xs_6 = [(children = singleton_1(createElement("div", createObj(ofArray([["style", {
        display: "flex",
    }], (elems_1 = [createElement("a", createObj(ofArray([["href", "https://safe-stack.github.io/"], (elems = [createElement("img", {
        src: "/favicon.png",
        alt: "Logo",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))), createElement("h1", {
        children: "ClamAV Security Scanner",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))), createElement("header", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    })), createElement("main", createObj(singleton_1((elems_3 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: 100 + "%",
        gap: 20 + "px",
    }], (elems_2 = [createElement(FileDrop, null)], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))]))))];
    return react.createElement(react.Fragment, {}, ...xs_6);
}

export function App() {
    let elements;
    const patternInput = useFeliz_React__React_useState_Static_1505(RouterModule_urlSegments(window.location.hash, 1));
    const patternInput_1 = useReact_useReducer_2B9E6EA0(update, init());
    return RouterModule_router(createObj(ofArray([["onUrlChanged", patternInput[1]], (elements = toList(delay(() => singleton(view(patternInput_1[0], patternInput_1[1])))), ["application", react.createElement(react.Fragment, {}, ...elements)])])));
}

